import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress Safari "Script error." from Share button and cross-origin scripts
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || e.message === 'Script error') {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />,
);
